import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import { faTicket } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from "../config";
import { useInvoiceContext } from "../context/InvoiceContext";

import ButtonNext from "./ButtonNext";

const Coupon = () => {
  const queryString = new URLSearchParams(useLocation().search);
  const couponable = queryString.get("couponable");
  const couponUrlCode = queryString.get("coupon");

  const [visible, setVisible] = useState(false);
  const [validCoupon, setValidCoupon] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonText, setButtonText] = useState("Aplicar Cupom");

  const { invoiceTotal, setInvoiceDiscount, invoiceDiscount, setIDDiscount, setDiscountType, setDiscountPerc } = useInvoiceContext();

  const [price, cents] = invoiceTotal.toFixed(2).split(".");
  const formattedCents = cents.padStart(2, "0");

  const [discount, discountCents] = invoiceDiscount.toFixed(2).split(".");
  const formattedDiscountCents = discountCents.padStart(2, "0");

  const applyDiscount = (coupon) => {

    setDiscountType(coupon.tipo_desconto);
    if (coupon.tipo_desconto === "$") {
      setInvoiceDiscount(parseFloat(coupon.valor_desconto));
    }

    if (coupon.tipo_desconto === "%") {
      setDiscountPerc(coupon.valor_desconto);
      setInvoiceDiscount(invoiceTotal * (coupon.valor_desconto / 100));
    }

    setValidCoupon(true);
    setErrorMessage(null);
    setIDDiscount(coupon.id);
    setIsDisabled(true);
    setButtonText("Cupom Aplicado");
  }

  const checkCoupon = async () => {
    setIsDisabled(true);
    setIsLoading(true);
    const response = await fetch(`${API_BASE_URL}/coupon/${couponCode}`);
    const jsonData = await response.json();

    const status = response.status;

    if (status === 400)
    {
      setValidCoupon(false);
      setErrorMessage(jsonData.message);
      setIsDisabled(false);
    }

    if (jsonData === null || status !== 400)
    {
      setValidCoupon(false);
      setErrorMessage("Erro ao validar cupom");
      setIsDisabled(false);
    }

    if (status === 200)
    {
      applyDiscount(jsonData);
    }

    setIsLoading(false);
  }

  useEffect(
    () => {
      if (couponable !== null && couponable === "true") {
        setVisible(true);
      }
    }, [],
  );

  useEffect(
    () => {
      if (couponUrlCode !== null) {
        setVisible(true);
        setCouponCode(couponUrlCode);
      }
    }, [couponUrlCode],
  );

  useEffect(
    () => {
      if (couponCode !== "" && invoiceTotal > 0) {
        checkCoupon();
      }
    }, [couponCode, invoiceTotal],
  );

  return (
    <Card className="p-3" style={{ display: visible ? "block" : "none" }}>
      <Row className="mb-3">
        <Col xs={12} className="d-flex align-items-center">
          <label style={styles.label_desconto}>Cupom de Desconto:</label>
        </Col>
        <Col xs={6}>
          <input
            type="text"
            className="form-control"
            placeholder="Código do Cupom"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") checkCoupon();
            }}
            disabled={isDisabled}
          />
        </Col>
        <Col xs={6} className="d-grid gap-2">
          <ButtonNext
            variant="warning"
            text={buttonText}
            faicon={isDisabled ? null : faTicket}
            isLoading={isLoading}
            disabled={isDisabled}
            onClick={checkCoupon}
          />
        </Col>
        <Col xs={12} className="d-flex align-items-center" style={styles.errorContainer}>
          <span style={styles.error}>
            {!validCoupon ? errorMessage : null}
          </span>
        </Col>
      </Row>  

      <Row style={{ display: validCoupon ? "block" : "none" }}>
        <Col xs={6} className="d-flex align-items-center">
          <Col xs={6} className="d-flex align-items-center">
            <label style={styles.label_desconto}>Subtotal:</label>
          </Col>
          <Col xs={12} className="d-flex align-items-center">
            <span style={styles.total}>
              <span style={styles.strikethrough}>
                <span style={styles.strikethroughLine}></span>
                {" R$ " + price }
                <span style={styles.subcents}>,{formattedCents}</span>
              </span>
            </span>
          </Col>
        </Col>
        <Col xs={12} className="d-flex align-items-center"></Col>
        <Col xs={6} className="d-flex align-items-center">
          <Col xs={6} className="d-flex align-items-center">
            <label style={styles.label_desconto}>Descontos:</label>
          </Col>
          <Col xs={12} className="d-flex align-items-center">
          <span style={styles.total}>
              {" R$ " + discount}
              <span style={styles.cents}>,{formattedDiscountCents}</span>
            </span>
          </Col>
        </Col>
      </Row>
    </Card>
  );
};

const styles = {
  total: {
    fontSize: "20px",
    color: "#333",
  },
  text: {
    fontSize: "20px",
    color: "#333",
  },
  cents: {
    fontSize: "15px",
    color: "#333",
    position: "relative",
    top: "-5px",
  },
  subcents: {
    fontSize: "15px",
    color: "#999",
    position: "relative",
    top: "-5px",
  },
  label_desconto: {
    fontSize: "14px",
    color: "#333",
  },
  strikethrough: {
    position: "relative",
    display: "inline-block",
    color: "#999",
  },
  strikethroughLine: {
    position: "absolute",
    top: "50%",
    left: "-1px", // Extende para a esquerda
    right: "-1px", // Extende para a direita
    height: "2px", // Espessura da linha
    backgroundColor: "#999", // Cor da linha
    content: '""',
  },
  errorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  error: {
    fontSize: "14px",
    color: "#ff0000",
  },
};

export default Coupon;
